import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
interface AIInlineHintProps {
  hint: string;
  explanation?: string;
  variant?: 'default' | 'compact';
}
export const AIInlineHint: React.FC<AIInlineHintProps> = ({
  hint,
  explanation,
  variant = 'default'
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  if (variant === 'compact') {
    return <div className="inline-block" style={{
      background: 'linear-gradient(90deg, rgba(255, 0, 77, 1) 0%, rgba(116, 10, 214, 1) 100%)',
      padding: '1px',
      borderRadius: '12px'
    }} data-id="element-130">
        <div className="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs bg-white text-black" style={{
        borderRadius: '11px'
      }} data-id="element-131">
          <span data-id="element-132">{hint}</span>
        </div>
      </div>;
  }
  return <div style={{
    background: 'linear-gradient(90deg, rgba(255, 0, 77, 1) 0%, rgba(116, 10, 214, 1) 100%)',
    padding: '1px',
    borderRadius: '12px'
  }} data-id="element-133">
      <div className="bg-white px-3 py-2" style={{
      borderRadius: '11px'
    }} data-id="element-134">
        <div className="flex items-start gap-2" data-id="element-135">
          <div className="flex-1" data-id="element-136">
            <p className="text-sm text-black" data-id="element-137">{hint}</p>
            {explanation && <>
                <button onClick={() => setIsExpanded(!isExpanded)} className="flex items-center gap-1 text-xs transition-colors mt-1" style={{
              color: '#740AD6'
            }} onMouseEnter={e => {
              e.currentTarget.style.color = '#FF004D';
            }} onMouseLeave={e => {
              e.currentTarget.style.color = '#740AD6';
            }} data-id="element-138">
                  Perché?
                  {isExpanded ? <ChevronUp className="h-3 w-3" data-id="element-139" /> : <ChevronDown className="h-3 w-3" data-id="element-140" />}
                </button>
                {isExpanded && <div className="mt-2 pt-2" style={{
              borderTop: '1px solid rgba(116, 10, 214, 0.2)'
            }} data-id="element-141">
                    <p className="text-xs text-gray-600" data-id="element-142">{explanation}</p>
                    <p className="text-xs text-gray-400 mt-1" data-id="element-143">
                      Basato su dati aggregati. Nessun dato personale.
                    </p>
                  </div>}
              </>}
          </div>
        </div>
      </div>
    </div>;
};